"use client";

import React from "react";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { NHSContentProps } from "@/types/confirmation-types";

import Styles from "./ghic-promotion.module.css";

function GhicPromotion({
  nhsTitle,
  nhsContent,
  nhsBtnLabel,
  nhsBtnLink,
}: Readonly<NHSContentProps>) {
  const onClickHandler = () => {
    window.open(nhsBtnLink, "_blank");
  };

  return (
    <div>
      {/* <div className=" hidden lg:block bg-surface-neutral-option-1 rounded-radius-xxl p-spacing-m md:p-spacing-l lg:p-spacing-xl space-y-spacing-s md:space-y-spacing-m h-fit"> */}
      <div className="flex flex-col gap-spacing-m md:gap-spacing-l">
        <h1 className="flex flex-row justify-between font-header-font text-nhs-header-text text-[23px] md:text-[31px] leading-[28px] md:leading-[34.1px]">
          {nhsTitle}
        </h1>

        <div>
          <p className="text-xs font-normal leading-custom-size-xxl text-nhs-paragraph-text">
            {nhsContent}
          </p>
        </div>
        <div className={Styles.ghicPromotion}>
          {nhsBtnLabel && (
            <LabelButtonWrapper
              data-testid="ghic-promotion-testid"
              id="ghic-promotion-button"
              isDisabled={false}
              label={nhsBtnLabel}
              hierarchy="secondary"
              className={`${Styles.findoutBtn} !w-[161px] px-spacing-m py-spacing-s`}
              type="button"
              onClick={onClickHandler}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default GhicPromotion;
